import React, { useEffect, useState } from "react";
import { Link, useLoaderData, useParams } from "react-router-dom";
import useFetch from "./helpers/useFetch";
import { NotifError, NotifSuccess, PageHeaderLink } from "./helpers/elements";
import { useDeviceWidth } from "./useDeviceWidth";
import axios from "axios";

const UpdateAppScreenshotReplace = (props) => {
    const { appNameId, screenshotId } = useParams();
    const { app } = useLoaderData();
    const appData = app?.data;
    const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();
    // const [appData] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/${id}/`);
    const [appScreenshotData] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/screenshot/${screenshotId}/`);
    const [isDeleteSubmit, setIsDeleteSubmit] = useState(false);
    const [isReplaceSubmit, setIsReplaceSubmit] = useState(false);
    const [appScreenshotReplace, setAppScreenshotReplace] = useState([]);
    const [appScreenshotReplacePreview, setAppScreenshotReplacePreview] = useState([]);
    const [updateAppScreenshotReplaceResponseData, setUpdateAppScreenshotReplaceResponseData] = useState({});

    useEffect(() => {
        if (appScreenshotReplacePreview.length < 4) {
            setAppScreenshotReplacePreview(
                appScreenshotReplace?.map((file) => URL.createObjectURL(file))
            );
        }
    }, [appScreenshotReplace]);

    const handleAppScreenshotReplaceSelect = (event) => {
        const files = Array.from(event.target.files);
        setAppScreenshotReplace(files);
        // setAppScreenshotReplacePreview(
        //     files.map((file) => URL.createObjectURL(file))
        // );
    };


    const showDeleteLoadingState = (e) => {
        setIsDeleteSubmit(true);
    };

    const showReplaceLoadingState = (e) => {
        setIsReplaceSubmit(true);
    };


    const updateScreenshotReplaceForm = (event) => {
        event.preventDefault();
        const formData = new FormData();
        // if (appImage) {
        //     formData.append("logo", appImage);
        // }
        appScreenshotReplace.forEach((file, index) => {
            // formData.append(`images[${index}]`, file)
            formData.append(`screenshots`, file)
        });
        const updateAppURL = `${process.env.REACT_APP_BASE_URL}/app/screenshot/${screenshotId}/delete/`;
        const headers = {
            'Accept': '*/*',
            // 'Origin': '*',
            'Authorization': `Bearer ${window.localStorage.getItem('nine_login')}`
        };
        const fetchConfig = {
            method: 'PATCH',
            headers: headers,
            mode: 'cors',
            // body: formData,
            data: formData,
            cache: 'default',
        };
        // fetch(updateAppURL, fetchConfig)
        axios(updateAppURL, fetchConfig)
            .then(response => {
                if (response.status !== 200) throw response;
                // return response.json()
                return response.data
            })
            .then(data => {
                setIsReplaceSubmit(false);
                setUpdateAppScreenshotReplaceResponseData({
                    message: "App logo update successful",
                    successful: true,
                    error: false
                });
            })
            .catch((error) => {
                // let error_message;
                // if (error.status === 401) {
                //     error_message = "Kindly login to update your Profile"
                // } else if (error.status === 400) {
                //     error_message = "Unable to perform update. Kindly fix any form errors and re-submit"
                // } else if (error.status === 500) {
                //     error_message = "Check your internet connection"
                // } else {
                //     // There is no network connection or the Server is not up.
                //     error_message = "Network Error"
                // }
                const errorMessage = error.response?.data.error || "Unable to process request";
                setUpdateAppScreenshotReplaceResponseData({
                    message: errorMessage,
                    successful: false,
                    error: true
                });
                // reset the isSubmit loader
                setIsReplaceSubmit(false);
            });
    };

    const handleScreenshotReplace = (event) => {
        event.preventDefault();
        let screenshotDeleteSuccessful = true;
        // First delete the Image and if successful, replace the screenshot
        const deleteAppURL = `${process.env.REACT_APP_BASE_URL}/app/screenshot/${screenshotId}/delete/`;
        const deleteHeaders = {
            'Accept': '*/*',
            // 'Origin': '*',
            'Authorization': `Bearer ${window.localStorage.getItem('nine_login')}`
        };
        const deleteFetchInit = {
            method: 'DELETE',
            headers: deleteHeaders,
            mode: 'cors',
            cache: 'default',
        };
        // fetch(deleteAppURL, deleteFetchInit)
        //     .then(response => {
        //         if (response.status !== 200) throw Error(response.error);
        //         response.json()
        //     })
        //     .then(data => {
        //         screenshotDeleteSuccessful = true;
        //     })
        //     .catch((error) => {
        //         screenshotDeleteSuccessful = false;
        //     });

        if (screenshotDeleteSuccessful) {
            const formData = new FormData();
            // if (appImage) {
            //     formData.append("logo", appImage);
            // }
            appScreenshotReplace.forEach((file, index) => {
                // formData.append(`images[${index}]`, file)
                formData.append(`screenshots`, file)
            });
            const updateAppURL = `${process.env.REACT_APP_BASE_URL}/app/screenshot/${screenshotId}/update/`;
            const headers = {
                'Accept': '*/*',
                // 'Origin': '*',
                'Authorization': `Bearer ${window.localStorage.getItem('nine_login')}`
            };
            const fetchConfig = {
                method: 'PATCH',
                headers: headers,
                mode: 'cors',
                // body: formData,
                data: formData,
                cache: 'default',
            };
            // fetch(updateAppURL, fetchConfig)
            axios(updateAppURL, fetchConfig)
                .then(response => {
                    if (response.status !== 200) throw response;
                    // return response.json()
                    return response.data
                })
                .then(data => {
                    setIsReplaceSubmit(false);
                    setUpdateAppScreenshotReplaceResponseData({
                        message: "App screenshot update successful",
                        successful: true,
                        error: false
                    });
                })
                .catch((error) => {
                    // let error_message;
                    // if (error.status === 401) {
                    //     error_message = "Kindly login to update your Profile"
                    // } else if (error.status === 400) {
                    //     error_message = "Unable to perform update. Kindly fix any form errors and re-submit"
                    // } else if (error.status === 500) {
                    //     error_message = "Check your internet connection"
                    // } else {
                    //     // There is no network connection or the Server is not up.
                    //     error_message = "Unable to update screenshot. Kindly retry"
                    // }
                    const errorMessage = error.response?.data.error || "Unable to process request";
                    setUpdateAppScreenshotReplaceResponseData({
                        message: errorMessage,
                        successful: false,
                        error: true
                    });
                    // reset the isSubmit loader
                    setIsReplaceSubmit(false);
                });
        }
    };
    const handleResetScreenshotPreview = () => {
        setAppScreenshotReplace([]);
    };
    return (
        <section className={"flex flex-row flex-nowrap justify-start dark:bg-111314"}>
            {
                windowWidth >= deviceWidthEnum.laptop
                    ? <section className={"pct:w-20 vh:h-100 bg-lighter dark:bg-000304 dark:every:color-whitesmoke"}>
                        <div
                            className={"flex flex-column justify-center align-items-start font-18 lh-normal pct:w-100 h-160 pad-x4 lg:font-24"}>
                            <div className={"font-size-inherit"}>Update</div>
                            <div className={"font-size-inherit font-bold color-gray"}>{appData?.name}</div>
                        </div>
                        <section className={"d-block every:d-block|pad-4|radius|decoration-none|color-initial hover:every:bg-light dark:every:color-whitesmoke dark:hover:every:bg-222425"}>
                            <button className={"pct:w-100 text-left border-0 bg-initial cursor-pointer"} onClick={() => { window.history.back() }}>Screenshots</button>
                        </section>
                    </section>
                    : null
            }
            <form onSubmit={updateScreenshotReplaceForm} className={"pct:w-100 lg:pct:w-56|mg-r-auto|mg-t8"}>
                <PageHeaderLink />
                <section className={""}>
                    {/*<header className={"pad-x2 font-semibold h-5 lh-5"}>*/}
                    {/*    /!*Upload ScreenshotReplace of your app*!/*/}
                    {/*    /!*<span className={"d-block font-italic"}>You could upload this later</span>*!/*/}
                    {/*</header>*/}
                    {
                        updateAppScreenshotReplaceResponseData?.successful
                            ? <NotifSuccess message={updateAppScreenshotReplaceResponseData.message} />
                            : null
                    }
                    {
                        updateAppScreenshotReplaceResponseData?.error
                            ? <NotifError message={updateAppScreenshotReplaceResponseData.message} />
                            : null
                    }
                    <section className={"pad-t4 pad-b2 bg-white-solid dark:bg-111314"}>
                        {
                            appScreenshotReplacePreview?.length < 1
                                ? (
                                    appScreenshotData?.image
                                        ? <img src={appScreenshotData?.image}
                                            alt={`${appData?.name} Screenshot`}
                                            height={"480"}
                                            // width={"80%"}
                                            className={"d-block pct:w-80 pct:max-w-80 mg-x-auto radius object-cover object-center"}
                                        />
                                        : <div
                                            className={"flex flex-column justify-center align-items-center pct:w-80 pct:max-w-80 h-480 mg-x-auto text-center border:2px_dashed_DDD radius color-999 hover:cursor-pointer transition:all_200ms_ease dark:bg-222425 dark:border:0px_solid_darkgray dark:hover:bg-333435"}>
                                            <span className="fa fa-plus font-28 pad-y2"></span>
                                        </div>
                                )
                                : <>
                                    <img src={appScreenshotReplacePreview[0]}
                                        alt={"replaced Screenshot"}
                                        height={"480"}
                                        // width={"80%"}
                                        className={"d-block pct:w-80 pct:max-w-80 mg-x-auto radius object-cover object-center"}
                                    />
                                </>
                        }
                        <div
                            className={"flex flex-row justify-center align-items-center pct:w-80 pct:max-w-80 mg-x-auto"}>
                            <label
                                htmlFor={"id-app-screenshot-upload"}
                                className={"flex flex-row justify-center align-items-center pct:w-100 h-6 lh-6 mg-y4 text-center border:2px_solid_BBB radius color-999 hover:cursor-pointer hover:bg-222425 transition:all_200ms_ease dark:bg-222425 dark:border:0px_solid_darkgray dark:hover:bg-333435"}>
                                {/*<span className="fa fa-plus pad-2"></span>*/}
                                <div>{"Change"}</div>
                                <input
                                    id={"id-app-screenshot-upload"}
                                    type="file"
                                    name={"screenshot"}
                                    hidden
                                    accept={"image/*"}
                                    onChange={handleAppScreenshotReplaceSelect}
                                />
                            </label>
                            {
                                appScreenshotReplacePreview?.length > 0
                                    ? <button
                                        type={"button"}
                                        className={"h-6 lh-6 mg-l1 mg-y1 pad-x2 radius text-center border:0px_solid_lightgray bg-red color-white"}
                                        onClick={handleResetScreenshotPreview}>
                                        <span className={"fa fa-times font-16"}></span>
                                    </button>
                                    : null
                            }
                        </div>

                    </section>
                    {/*<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className={"pct:w-100"}>*/}
                    {/*    <path d="M 0 78.5 C 0 14.130000000000004, 14.130000000000004 0 78.5 0 S 157 14.130000000000004, 157 78.5, 142.87 157, 78.5 157, 0 142.87, 0 78.5" fill="#FADB5F" transform="rotate(0,100,100) translate(21.521.5)" width="100%"></path>*/}
                    {/*</svg>*/}
                    <div className={"fixed bottom-0 flex flex-row flex-nowrap justify-center align-items-center pct:w-100 mg-x-auto mg-t-2 pad-y2 border:0px_solid_lightgray border-t-2 bg-white-solid every:h-6|lh-6|mg-x1|mg-y1|radius|text-center lg:pct:w-56|border-0 dark:bg-inherit"}>
                        {/*{
                            appScreenshotReplacePreview?.length < 1
                                ? <label
                                    htmlFor={"id-app-screenshot-upload"}
                                    className={"pct:w-60 border:2px_solid_lightgray bg-transparent"}>
                                    {"Replace screenshot"}
                                    <input
                                        id={"id-app-screenshot-upload"}
                                        type="file"
                                        name={"screenshot"}
                                        hidden
                                        accept={"image/*"}
                                        multiple
                                        onChange={handleAppScreenshotReplaceSelect}
                                    />
                                </label>
                                : null
                        }*/}
                        {/*<button type={"button"} className={"pct:w-60 border:2px_solid_lightgray bg-transparent"} onClick={handleScreenshotReplace}>
                            {isReplaceSubmit ? <span className='fa fa-spinner fa-spin'></span> : "Replace screenshot"}
                        </button>*/}

                        <button
                            type={"button"}
                            className={"pct:w-30 border-0 bg-green color-white disabled:bg-green-inverse"}
                            onClick={handleScreenshotReplace}
                            disabled={appScreenshotReplacePreview?.length < 1}>
                            {isReplaceSubmit ? <span className='fa fa-spinner fa-spin'></span> : "Save"}
                        </button>
                    </div>
                </section>
            </form>
        </section>
    )
}

export default UpdateAppScreenshotReplace;